// extracted by mini-css-extract-plugin
module.exports = {"main":"ProductBrowse_main__m2sY7","main-flex":"ProductBrowse_main-flex__2cVuu","mobile":"ProductBrowse_mobile__4cb_g","desktop":"ProductBrowse_desktop__jVVFr"};